// extracted by mini-css-extract-plugin
export default {"receiveTinContainer":"styles_receiveTinContainer__ZDK6g"};